import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const [form, setForm] = useState({ username: "", password: "" });
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/login", form);
      localStorage.setItem("rl_admin_token", data.token);
      navigate("/admin/dashboard");
    } catch {
      toast.error("Invalid admin credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FDF8F0] px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-md border border-[#E9DFC8] bg-white p-8 shadow-[0_30px_80px_-40px_rgba(143,110,29,0.3)]">
        <img src="/assets/brand/logo.png" alt="Rudralife" className="mx-auto mb-6 h-10 w-auto" />
        <h1 className="mb-1 text-center font-display text-3xl font-semibold text-[#2B1E12]">Admin Panel</h1>
        <p className="mb-7 text-center text-[10px] font-bold uppercase tracking-[0.26em] text-[#8F6E1D]">Rudralife Diwali 2026</p>
        <label className="mb-1.5 block text-xs uppercase tracking-wider text-[#6B5B45]">Admin ID</label>
        <input
          data-testid="admin-username"
          value={form.username}
          onChange={(e) => setForm({ ...form, username: e.target.value })}
          className="mb-4 w-full rounded-md border border-[#E0D3B4] bg-white px-4 py-3 text-sm text-[#2B1E12] outline-none focus:border-[#B08D2B]"
          autoComplete="username"
        />
        <label className="mb-1.5 block text-xs uppercase tracking-wider text-[#6B5B45]">Password</label>
        <input
          data-testid="admin-password"
          type="password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          className="mb-6 w-full rounded-md border border-[#E0D3B4] bg-white px-4 py-3 text-sm text-[#2B1E12] outline-none focus:border-[#B08D2B]"
          autoComplete="current-password"
        />
        <button
          data-testid="admin-login-submit"
          disabled={busy}
          className="flex w-full items-center justify-center gap-2 bg-[#D4AF37] py-3.5 text-[11px] font-bold uppercase tracking-[0.22em] text-[#1C130B] transition-colors hover:bg-[#8F6E1D] hover:text-white disabled:opacity-60"
        >
          <Lock className="h-4 w-4" /> {busy ? "Signing in…" : "Sign In"}
        </button>
        <a href="/" className="mt-5 block text-center text-xs text-[#6B5B45] transition-colors hover:text-[#8F6E1D]">← Back to store</a>
      </form>
    </div>
  );
}
